import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { fn } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { service } from "@ember/service";
import {
  addUniqueValueToArray,
  removeValueFromArray,
} from "discourse/lib/array-tools";
import { eq } from "discourse/truth-helpers";
import DButton from "discourse/ui-kit/d-button";
import dCategoryBadge from "discourse/ui-kit/helpers/d-category-badge";
import { i18n } from "discourse-i18n";
import {
  categoryName,
  findCategory,
  groupName,
} from "../lib/category-groups";
import FrlEditGroup from "./frl-edit-group";

export default class FrlCategoryGroup extends Component {
  @service modal;

  @tracked selectedCategoryId = null;

  @action
  edit() {
    this.args.editCategoryGroup(this.args.categoryGroup);
  }

  @action
  delete() {
    this.args.deleteCategoryGroup(this.args.categoryGroup);
  }

  @action
  addGroup() {
    this.modal.show(FrlEditGroup, {
      model: {
        groups: this.args.groups,
        currentGroups: this.args.categoryGroup.groups,
      },
    });
  }

  @action
  editGroup(group) {
    this.modal.show(FrlEditGroup, {
      model: {
        groups: this.args.groups,
        currentGroups: this.args.categoryGroup.groups,
        group,
      },
    });
  }

  @action
  removeGroup(group) {
    removeValueFromArray(this.args.categoryGroup.groups, group);
  }

  @action
  selectCategory(event) {
    this.selectedCategoryId = parseInt(event.target.value, 10);
  }

  @action
  addCategory() {
    const categoryId = this.selectedCategoryId;

    if (isNaN(categoryId) || categoryId === null) {
      return;
    }

    addUniqueValueToArray(this.args.categoryGroup.categories, categoryId);
    removeValueFromArray(this.args.availableCategoryIds, categoryId);
    this.selectedCategoryId = null;
  }

  @action
  deleteCategory(categoryId) {
    removeValueFromArray(this.args.categoryGroup.categories, categoryId);
    addUniqueValueToArray(this.args.availableCategoryIds, categoryId);
  }

  <template>
    <div class="frl-category-group">
      <div class="frl-section">
        <h2>{{@categoryGroup.name}}</h2>

        <DButton
          @action={{this.edit}}
          @icon="pencil"
          @label="flexible_rate_limits.admin.edit"
          class="btn-primary"
        />

        <DButton
          @action={{this.delete}}
          @icon="xmark"
          @label="flexible_rate_limits.admin.delete"
          class="btn-danger"
        />
      </div>

      <div class="frl-section">
        <h3>{{i18n "flexible_rate_limits.admin.group"}}</h3>

        <table class="table frl-table">
          <thead>
            <tr>
              <th>{{i18n "flexible_rate_limits.admin.group_name"}}</th>
              <th>{{i18n "flexible_rate_limits.admin.post_limit"}}</th>
              <th>{{i18n "flexible_rate_limits.admin.topic_limit"}}</th>
              <th>{{i18n "flexible_rate_limits.admin.cooldown"}}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {{#each @categoryGroup.groups as |group|}}
              <tr>
                <td>{{groupName @groups group.id}}</td>
                <td>{{group.post_limit}}</td>
                <td>{{group.topic_limit}}</td>
                <td>{{group.cooldown}}</td>
                <td>
                  <DButton
                    @action={{fn this.editGroup group}}
                    @icon="pencil"
                    class="btn-primary"
                  />
                  <DButton
                    @action={{fn this.removeGroup group}}
                    @icon="xmark"
                    class="btn-danger"
                  />
                </td>
              </tr>
            {{/each}}

            <tr>
              <td>{{i18n "flexible_rate_limits.admin.default"}}</td>
              <td>{{@categoryGroup.post_limit}}</td>
              <td>{{@categoryGroup.topic_limit}}</td>
              <td>{{@categoryGroup.cooldown}}</td>
              <td></td>
            </tr>
          </tbody>
        </table>

        <div class="frl-actions">
          <DButton
            @action={{this.addGroup}}
            @label="flexible_rate_limits.admin.add_group"
            @icon="plus"
            class="btn-primary"
          />
        </div>
      </div>

      <div class="frl-section">
        <h3>{{i18n "flexible_rate_limits.admin.category"}}</h3>

        {{#each @categoryGroup.categories as |categoryId|}}
          <div class="frl-category">
            {{dCategoryBadge (findCategory categoryId) allowUncategorized=true}}
            <DButton
              @action={{fn this.deleteCategory categoryId}}
              @icon="xmark"
              @title="flexible_rate_limits.admin.delete"
              class="btn-transparent frl-delete"
            />
          </div>
        {{/each}}

        <div class="frl-actions">
          <select {{on "change" this.selectCategory}}>
            <option value="">{{i18n
                "flexible_rate_limits.admin.select_category"
              }}</option>

            {{#each @availableCategoryIds as |categoryId|}}
              <option
                value={{categoryId}}
                selected={{eq categoryId this.selectedCategoryId}}
              >{{categoryName categoryId}}</option>
            {{/each}}
          </select>

          <DButton
            @action={{this.addCategory}}
            @label="flexible_rate_limits.admin.add_category"
            @icon="plus"
            class="btn-primary"
          />
        </div>
      </div>
    </div>
  </template>
}
